<template>
  <div class="arrangeListDiv">
    <div style="padding: 20px; background: #fff">
      <div class="arrangeTitle">{{ detailInfo?.info?.form_name }}</div>
      <div class="czDiv">
        <div class="expertInfo">
          <div class="mb15">
            <span class="unit">专家姓名：</span>
            <span class="valueFont">{{ detailInfo?.info?.name }}</span>
          </div>
          <div class="mb15">
            <span class="unit"><span class="unitSpan">单</span>位：</span>
            <span class="valueFont">{{ detailInfo?.info?.org_name }}</span>
          </div>
          <div class="mb15">
            <span class="unit">专业领域：</span>
            <span class="valueFont">{{ detailInfo?.info?.area }}</span>
          </div>
        </div>
        <div class="printBtn">
          <el-button type="primary" size="small" @click="handleRow('goPrint')"
            >前往打印</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          :data="detailInfo?.list"
          style="width: 100%"
          class="custom-table"
        >
          <el-table-column type="index" label="排名" width="50" align="center">
          </el-table-column>
          <el-table-column prop="project_name" label="项目名称" align="center">
          </el-table-column>
                 <el-table-column prop="declarant_name" label="申报人" align="center">
          </el-table-column>
          <!-- 动态维度列 -->
          <el-table-column
            v-for="key in dimensionKeys"
            :key="key"
            :prop="key"
            :label="dimensionTitles[key]"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="expert_opinion"
            label="专家具体意见"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.expert_opinion"
                placement="top-start"
              >
                <span>{{
                  scope.row.expert_opinion &&
                  scope.row.expert_opinion.length > 20
                    ? scope.row.expert_opinion.substring(0, 20) + "..."
                    : scope.row.expert_opinion
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            prop="saved_score"
            label="分数"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="time" label="专家意见" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.expert_opinion ? "是" : "否" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="qmDiv">
        <div class="valueFont mb15 w141">
          专家签名：
          <el-button
            v-if="!detailInfo.info?.signature_url"
            type="primary"
            size="small"
            @click="handleRow('goSignature')"
            >上传签名</el-button
          >
          <img
            :src="detailInfo.info?.signature_url"
            @click="lookSignature(detailInfo.info?.signature_url)"
            alt=""
            style="width: 150px; height: 50px"
            v-else
          />
        </div>
        <div class="valueFont w141">
          <span class="unitSpan">日</span>期：{{
            detailInfo.info?.signature_date
          }}
        </div>
      </div>
      <div class="goBack">
        <div class="goBackBtn">
          <el-button type="primary" size="small" @click="handleRow('goBack')"
            >返回</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="专家签名"
      :visible.sync="uploadDialogVisible"
      width="1000px"
      :before-close="closeUploadDialog"
    >
      <div
        style="
          padding: 15px 0;
          font-size: 14px;
          text-align: center;
          color: #666;
        "
      >
        请在下方区域内签名
      </div>
      <SignaturePad
        v-model="signatureDataUrl"
        :width="950"
        :height="300"
        :lineWidth="2"
        lineColor="#000000"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSignature">确认签名</el-button>
        <el-button @click="closeUploadDialog">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SignaturePad from "../components/SignaturePad.vue";
import { getBaseUrl } from "@/config";
export default {
  name: "expertReviewList",
  components: {
    SignaturePad,
  },
  data() {
    return {
      baseURL: getBaseUrl(),
      uploadDialogVisible: false,
      signatureDataUrl: "",
      detailInfo: {},
      xid: "",
      expertXid:'',
      // 动态维度配置
      dimensionTitles: {},
      dimensionKeys: []
    };
  },
  mounted() {
    this.xid = this.$route.query.xid;
    this.expertXid = this.$route.query.expert_xid;
    this.getExpertReviewList();
  },
  methods: {
    lookSignature(e) {
      window.open(e, "_blank");
    },
    submitSignature() {
      if (!this.signatureDataUrl) {
        this.$message.warning("请先签名");
        return;
      }
      // this.$message.warning("正在上传签名，请稍候...");

      // 将 base64 转换为 Blob 对象
      const blob = this.base64ToBlob(this.signatureDataUrl, "image/png");
      const file = new File([blob], "signature.png", { type: "image/png" });

      // 创建 FormData
      const formData = new FormData();
      formData.append("file", file);

      // 调用上传接口
      this.$API
        .uploadFile(formData)
        .then((res) => {
          // 上传成功，保存签名 URL
          return this.$API.saveSignature({
            arrange_xid: this.xid,
            signature_url: res.url, // 假设返回的 URL 在 res.data.url
          });
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.uploadDialogVisible = false;
          this.getExpertReviewList();
        })
        .catch((err) => {
          console.error("上传失败:", err);
          this.$message.error("上传失败");
        });
    },
    // 将 base64 转换为 Blob
    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64.split(",")[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mimeType });
    },
    closeUploadDialog() {
      this.uploadDialogVisible = false;
      this.signatureDataUrl = "";
    },
    getExpertReviewList() {
      this.$API.getExpertReviewDetail({ arrange_xid: this.xid }).then((res) => {
        this.detailInfo = res.data;
        console.log("res============", res);
        // 动态设置维度标题和键
        if (res.data?.title) {
          this.dimensionTitles = res.data.title;
          this.dimensionKeys = Object.keys(res.data.title);
        }
        // 如果已有签名，加载到签名板
        if (res.data?.info?.signature_url) {
          this.$nextTick(() => {
            // SignaturePad 组件会通过 watch value 自动加载
          });
        }
      });
    },
    checkSavedScore(data) {
      return data.every(
        (item) => item.saved_score !== null && item.saved_score !== 0
      );
    },
    handleRow(type) {
      switch (type) {
        case "goPrint":
                window.open(`${this.baseURL}/frontend/home/goPrint?arrange_xid=${this.xid}&expert_xid=${this.expertXid}`);
          break;
        case "goBack":
          this.$router.go(-1);
          break;
        case "goSignature":
          //判断是否有未打分的
          const result = this.checkSavedScore(this.detailInfo?.list);
          if (!result) {
            this.$message.error("有人员还未进行打分,请先完善打分");
            return;
          }
          this.signatureDataUrl = "";
          this.uploadDialogVisible = true;
          break;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.w141 {
  width: 342px;
  display: flex;
  align-items: center;
}
.qmDiv {
  display: flex;
  flex-direction: column;
  align-items: end;
  margin-top: 30px;
}
.valueFont {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.mb15 {
  margin-bottom: 15px;
}
.unitSpan {
  letter-spacing: 30px;
}
.unit {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.czDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.goBackBtn {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  padding-right: 60px;
}
.goBack {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 60px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
}
::v-deep .el-table__header-wrapper th {
  background: #f2f5fb !important;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111827;
}
.arrangeTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #231815;
  text-align: center;
}
.arrangeListDiv {
  width: 100%;
  height: 700px;
  border-radius: 6px;
  background: #fff;
}
</style>
